import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="policy-card about-card">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            Choicest Fruit<span className="small-r-symbol">®</span> is a social enterprise rooted in the belief that
            communities have the power to shape their own future. We bring together people of all ages and
            backgrounds to learn, create, and collaborate on projects that uplift communities and benefit
            humanity.
          </p>

          <p className="about-text">
            We are educators, innovators, youth, seniors, and community members working side by side. Together,
            we explore technology, foster creativity, and build skills that not only prepare individuals for the
            future but also strengthen the moral and social fabric of our communities.
          </p>

          <p className="about-text">
            Our vision is to{" "}
            <span className="purple">empower young people, underserved populations and seniors</span> to become active
            participants in the development of technology that promotes positive relationships with themselves,
            others, and the world. We aim to equip individuals with the awareness, values, and skills needed to
            contribute to just and thriving societies through responsible tech practices.
          </p>

          <p className="about-text">
            By integrating local experiences and diverse perspectives into the tech development process, we
            ensure that technology is designed, distributed, and used in ways that reflect the unique needs and
            values of our communities.
          </p>

          <p className="about-text">
            The name Choicest Fruit<span className="small-r-symbol">®</span> symbolizes the idea that, just as the best
            fruit comes from the healthiest tree, the most valuable technologies and innovations are the result
            of <span className="purple">nurturing knowledge</span> and <span className="purple">thoughtful choices</span>.
          </p>

          <p className="about-text">
            A core principle of Choicest Fruit is infusing <span className="purple">human values</span> into the tech
            development process. We teach young people to consider the broader impacts of technology at every
            stage, encouraging them to move beyond simply replicating market-driven trends.
          </p>

          <div className="about-quote" aria-label="Quote">
            “… In this day the choicest fruit of the tree of knowledge is that which serveth the welfare of
            humanity and safeguardeth its interests.“
          </div>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
